module.exports = __webpack_public_path__ + "img/side-back.574fb015.svg";